module.exports = __webpack_public_path__ + "img/bh.4f041370.svg";